import React from "react"
import Card from "@engaging-tech/components/dist/lib/Card/Card"
import Flex from "@engaging-tech/components/dist/lib/Flex/Flex"
import { Authenticator } from "@aws-amplify/ui-react"
import NewNav from "../features/navigation/components/NewNav"
import { Components, FormFields } from "../features/auth/components/SignIn"

const BaseLayout = ({ bg = "transparent", children, ...props }) => (
  <Authenticator
    formFields={FormFields}
    components={Components}
    hideSignUp


    // socialProviders={["google"]}
  >
    {({ signOut, user }) => (
      <>
        <NewNav signOut={signOut} user={user} />
        <Flex mx={[4, 4, 0]} flexDirection="column">
          <Flex justifyContent="center" bg={bg} {...props} width={1 / 1} pt={4}>
            <Card as="main" maxWidth={1024} elevation={0}>
              {children}
            </Card>
          </Flex>
        </Flex>
      </>
    )}
  </Authenticator>
)

export default BaseLayout
